// extracted by mini-css-extract-plugin
export var closeButton = "_3f-3";
export var header = "_3f-0";
export var link = "_3f-1";
export var retryButton = "_3f-2";